import { useSearchParams } from "react-router-dom"

import { useAuth } from "@/contexts/auth"
import { DateHelper } from "@/utils"
export const useScheduleSearchParams = () => {
  const [searchParams] = useSearchParams()
  const { selectedWhiteLabel } = useAuth()
  const currentDate = DateHelper.currentDate()
  const stringStartDate =
    DateHelper.startOfMonth(currentDate)
  const stringEndDate = DateHelper.endOfMonth(currentDate)
  const whitelabel_ids = selectedWhiteLabel?.uuid
  const startDate = new Date(
    DateHelper.formatToISO(stringStartDate)
  )
  const params: ScheduleSearchingParamsType = {
    page: Number(searchParams.get("page")) || 1,
    quantity: Number(searchParams.get("pageSize")) || 10,
    date: searchParams.get("date") || String(currentDate),
    startDate:
      searchParams.get("startDate") || stringStartDate,
    endDate: searchParams.get("endDate") || stringEndDate,
    currentDate:
      searchParams.get("currentDate") || currentDate,
    whitelabel_ids:
      searchParams.get("whitelabel_ids") || whitelabel_ids,
    status_installment: "CANCELLED",
  }
  return { params, startDate }
}
export default useScheduleSearchParams
